export const getDomain = (currentUrl) => {
    const isLocalhost = currentUrl.includes("localhost");
    if (isLocalhost) {
        // return "http://app.expressleather.local";
        return "https://expressleather.app";
    } else {
        return new URL(currentUrl).origin;
    }
}